;(() => {
  const pluralRulesCache = new Map()
  const numberFormatCache = new Map()

  function pluralRulesFor(locale) {
    let rules = pluralRulesCache.get(locale)
    if (!rules) {
      rules = new Intl.PluralRules(locale)
      pluralRulesCache.set(locale, rules)
    }
    return rules
  }

  function numberFormatFor(locale) {
    let numberFormat = numberFormatCache.get(locale)
    if (!numberFormat) {
      numberFormat = new Intl.NumberFormat(locale)
      numberFormatCache.set(locale, numberFormat)
    }
    return numberFormat
  }

  function pluralize(count, labels, locale) {
    if (!labels) return String(count)
    const resolvedLocale = locale || "en"
    const key = pluralRulesFor(resolvedLocale).select(count)
    const label = labels[key] || labels.other || labels.one
    const formattedCount =
      typeof count === "number"
        ? numberFormatFor(resolvedLocale).format(count)
        : String(count)
    if (!label) return formattedCount
    return label.replaceAll("%{count}", formattedCount).trim()
  }

  window.HB = window.HB || {}
  window.HB.pluralize = pluralize
})()
